import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-header-sp',
  templateUrl: './header-sp.component.html',
  styleUrls: ['./header-sp.component.less'],
})
export class HeaderSpComponent {
  @Input() imagemLoja = 'assets/img/logo_krabo.png';
  @Input() nomeEntidade?: string;
  @Input() ssn?: string;

  @Input() url: string = '';

  subdominioLoja?: string;

  constructor() {}

  // (click)="goToLink(url)"
  goToLink(url: string) {
    if (url) {
      window.open(url, '_blank');
    } else {
      return;
    }
  }
}
